import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "./components/site/Nav";
import { Footer } from "./components/site/Footer";
import { CTABand } from "./components/site/CTABand";
// eslint-disable-next-line no-unused-vars
import Home from "./pages/Home";
import Research from "./pages/Research";
import Projects from "./pages/Projects";
import Publications from "./pages/Publications";
import Teaching from "./pages/Teaching";
import Lab from "./pages/Lab";
import About from "./pages/About";
import Contact from "./pages/Contact";
// Home landing page kept in codebase but no longer routed (About is now the homepage)

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Layout = () => {
  const { pathname } = useLocation();
  return (
    <>
      <a href="#main" className="skip-link" data-testid="skip-link">Skip to content</a>
      <Nav />
      <main id="main">
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/research" element={<Research />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/teaching" element={<Teaching />} />
          <Route path="/lab" element={<Lab />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      {pathname !== "/contact" && <CTABand />}
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Layout />
    </BrowserRouter>
  );
}

export default App;
